export const tabList = [
  { label: "同仁", key: 1 },
  { label: "山西", key: 2 },
  { label: "呼和浩特", key: 3 },
  { label: "珠海", key: 4 }
];
